:host {
  display: block;
}

.spw-footer-bottom {
  background: var(--spw-color-shades-base-black);
  color: var(--spw-ds-white);
  padding: 16px 0;

  &__content {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 24px;

    @include breakpoint(lg) {
      flex-direction: row;
      align-items: center;
    }
  }

  &__copyright {
    display: flex;
    align-items: center;
    &-title {
      font-style: italic;
      font-size: 16px;
    }
  }

  &__links {
    display: flex;
    flex-direction: column;
    gap: 12px;

    @include breakpoint(md) {
      flex-direction: row;
      gap: 0;
    }

    ::slotted(a) {
      display: inline-block;
      text-decoration: none !important;
      color: var(--spw-ds-white) !important;

      @include breakpoint(md) {
        display: flex;
        align-items: center;
        margin-right: 16px;
      }

      &:after {
        content: '';
        position: relative;
        margin-left: 16px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: var(--spw-ds-primary);
      }
    }
    ::slotted(a:hover) {
      color: var(--spw-colors-support-grey-grey-500) !important;
    }
    ::slotted(a:last-child) {
      margin-right: 0;
      &:after {
        display: none;
      }
    }
  }
  &__socials {
    display: flex;
    gap: 16px;
    a {
      color: white;
      &:hover {
        opacity: 0.8;
      }
    }
    spw-icon {
      font-size: 21px;
    }
  }
}
